<div class="wrapper" [ngClass]="{ selected: value, 'not-selected': !value }">
	<div class="option">{{ goal.option }}</div>
	<div class="value">
		<div *ngIf="value" class="yes"><i class="fa fa-check"></i></div>
		<div *ngIf="!value" class="no"><i class="fa fa-times"></i></div>
	</div>
</div>
